import { bind, Component, h, tag } from "omi";

import { NWCloseButton } from "@/wc/components/atoms/nw-button/closeButton.tsx";
import { PortfolioDocument } from "@/wc/pages/portfolio/store/models.ts";
import { NWButton } from "@/wc/components/atoms/nw-button";
import { NWIcon } from "@/wc/components/atoms/nw-icon";
import { PortfolioStore } from "@/wc/pages/portfolio/store";
import { ModalProps } from "@/wc/components/modals";
import { tailwind } from "@/tailwind";

export type PortfolioDeleteModalData = PortfolioDocument;

type Props = ModalProps<PortfolioDeleteModalData>;

@tag("portfolio-delete-modal")
export class PortfolioDeleteModal extends Component<Props> {
  static css = [tailwind];

  @bind
  private async handleDelete() {
    const { data, close } = this.props;
    await PortfolioStore.deleteDocument(data);
    close();
  }

  render({ close, data }: Props) {
    const { title } = data;

    return (
      <div className="bg-white rounded-lg shadow-xl max-w-md p-6" role="dialog" aria-modal="true">
        <div class="content flex flex-col space-y-6">
          <div class="header flex items-start justify-between">
            <div class="p-3 bg-error-100 rounded-full flex items-center justify-center">
              <NWIcon name="trash" width={28} height={28}></NWIcon>
            </div>

            <NWCloseButton size="md" onClick={close} />
          </div>

          <div class="body">
            <div class="space-y-1">
              <h3 class="font-semibold text-lg text-primary">Delete {title}?</h3>
              <p class="text-secondary">Are you sure you want to delete this project? This action cannot be undone.</p>
            </div>
          </div>

          <div class="flex w-full flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-3">
            <NWButton type="secondary" className="w-full" size="full" onClick={close}>
              Cancel
            </NWButton>
            <NWButton
              type="danger"
              className="w-full"
              size="full"
              onClick={this.handleDelete}
              loading={PortfolioStore.deleteDocumentMutation.isLoading.value}
              loadingColor="white"
              loadingText="Delete"
            >
              Delete
            </NWButton>
          </div>
        </div>
      </div>
    );
  }
}
